export default __webpack_public_path__ + "static/media/hht2_ep4_speaking_02.e4c9448b.png";